import Backbone from 'backbone';

var Mobel_Project = Backbone.Model.extend({
    defaults: {
        project_key                   : '',
        account_id                    : 0,
        access_token                  : '',
        name                          : '',
        description                   : '',
        url                           : '',
        logo                          : '',
        feedback_is_shared            : true,
        feedback_allow_public_comment : false,
        feedback_allow_video_feedback : true,
        created_by                    : 0,
        create_time                   : 0,
        archive_time                  : 0,
        delete_time                   : 0,
        is_archived                   : false,
        project_type                  : 'feedback',
        type                          : 'local',
        engine_type                   : '',
        is_local_dismissed            : false,
        default_user_id               : 0,
        default_assignee_id_general   : 0,
        default_due_day_general       : 0,
        default_assignee_id_bug       : 0,
        default_due_day_bug          : 0,
        default_assignee_id_feature   : 0,
        default_due_day_feature      : 0,
        feedback_auto_reopen          : true,
        is_trust_domain_used          : false,
        discard_location              : false,
        basic_auth                    : '',
        http_header                   : '',
        ai_feedback_sentiment         : false,
        ai_feedback_action            : false,
        ai_feedback_title             : false
    },

    isSurvey: function() {
        return this.get('project_type') === 'survey';
    },

    isFeedback: function() {
        // TODO: change to === 'feedback' after migrating all the existing records
        return this.get('project_type') !== 'survey';
    },

    getForwardingEmail: function() {
        return 'feedback+pid.' + this.get('access_token') + '@mt.userback.io';
    }
});

export default Mobel_Project;